import * as RecaptchaPage from './components/RecaptchaPage.css';

export default {
	RecaptchaPage
};
